import { render, staticRenderFns } from "./SearchAutocompleteSingleItem.vue?vue&type=template&id=c9355138"
import script from "./SearchAutocompleteSingleItem.vue?vue&type=script&lang=js"
export * from "./SearchAutocompleteSingleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports